import { FormArray, FormGroup } from '@angular/forms';
import { CommissionsFormService } from '../services/commissions-table/commissions-form.service';
import { HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { ModalService } from '../services/modal/modal.service';
import { MessageService } from 'primeng/api';

export const getDirty = (form: any, formName: string): boolean | undefined => {
  return form.get(formName)?.invalid && form.get(formName)?.touched;
};

export const getType = (
  commissionFormService: CommissionsFormService
): string => {
  return commissionFormService.isProducer ? 'produttore' : 'coassicurazione';
};

export const exits = (value: any): boolean => {
  return value != null && value != undefined;
};

export const debugForm = (formGroup: FormGroup): void => {
  Object.keys(formGroup.controls).forEach((key) => {
    const control = formGroup.get(key);
    if (control instanceof FormGroup) {
      debugForm(control);
    } else if (control && control.invalid) {
      console.log(`Control: ${key}, Errors:`, control.errors, control);
    }
  });
};

export const logFormErrors = (formArray: FormArray): void => {
  formArray.controls.forEach((formGroup, index) => {
    Object.keys((formGroup as FormGroup).controls).forEach((controlName) => {
      const control = formGroup.get(controlName);
      if (control && control.invalid) {
        console.log(
          `Control ${controlName} in row ${index} is invalid:`,
          control.errors
        );
      }
    });
  });
};

export const handleError = (
  error: HttpErrorResponse,
  modalService: ModalService,
  messageService: MessageService
): void => {
  const code: string = error.status.toString();

  switch (code) {
    case '403':
    case '401': {
      modalService.showError(error);
      break;
    }
    default: {
      messageService.add({
        key: 'br',
        severity: 'error',
        summary: 'Errore',
        detail: error.error.message ?? 'Errore generico',
      });
    }
  }
};
//TODO: check if this function is usefull, i think the number are auto converted. For the string i need this method.
// export const convertComaInDot = (numberToConvert: number) : string =>{
//   return numberToConvert.toString().replace(',', '.');
// }

export function extractSessionIdFromJWT(token: string | null): string | null {
  if (!token) return null;
  try {
    const parts = token.split('.');
    if (parts.length < 2) return null;
    const decoded = JSON.parse(base64UrlDecode(parts[1]));
    return decoded.sessionId || null;
  } catch (e) {
    return null;
  }
}

function base64UrlDecode(input: string): string {
  input = input.replace(/-/g, '+').replace(/_/g, '/');
  while (input.length % 4) input += '=';
  return atob(input);
}

export function isJwtExpired(
  token: string | null,
  leewaySeconds = 0
): boolean | null {
  if (!token) return true;
  try {
    const parts = token.split('.');
    if (parts.length < 2) return true;
    const decoded = JSON.parse(base64UrlDecode(parts[1]));
    if (typeof decoded.exp !== 'number') return true;
    const now = Math.floor(Date.now() / 1000);
    return now >= (decoded.exp - leewaySeconds);
  } catch {
    return true;
  }
}